import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, NgForm, ValidationErrors } from '@angular/forms';
import { Router, ActivatedRoute } from "@angular/router"
import { NzMessageService } from 'ng-zorro-antd/message';
import { Observable, Observer } from 'rxjs';

import { ConfiguracaoService } from '../../services/configuracao.service';

@Component({
    selector: 'app-configuracao',
    templateUrl: './configuracao.component.html',
    styleUrls: ['./configuracao.component.css'],
    standalone: false
})
export class ConfiguracaoComponent implements OnInit {
  configuracaoForm!: UntypedFormGroup;

  constructor(
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private message: NzMessageService,
    private configuracaoService: ConfiguracaoService,
  ) {
    this.configuracaoForm = this.newForm();
  }


  ngOnInit(): void {

    this.configuracaoService.detalhar().subscribe((p: any) => {
      let item = p.data.configuracao;

      this.configuracaoForm.get('idconfiguracao').setValue(item.idconfiguracao);
      this.configuracaoForm.get('cnpj').setValue(item.cnpj);
      this.configuracaoForm.get('razao_social').setValue(item.razao_social);
      this.configuracaoForm.get('nome_fantasia').setValue(item.nome_fantasia);
      this.configuracaoForm.get('email').setValue(item.email);
      this.configuracaoForm.get('site').setValue(item.site);
      this.configuracaoForm.get('celular').setValue(item.celular);
      this.configuracaoForm.get('telefone').setValue(item.telefone);
    });

  }

  newForm() {
    return new UntypedFormGroup({
      idconfiguracao: new UntypedFormControl(''),
      cnpj: new UntypedFormControl('', [Validators.required]),
      razao_social: new UntypedFormControl('', [Validators.required]),
      nome_fantasia: new UntypedFormControl('', [Validators.required]),
      email: new UntypedFormControl('', [Validators.required]),
      celular: new UntypedFormControl('', [Validators.required]),
      telefone: new UntypedFormControl(''),
      site: new UntypedFormControl(''),
    });
  }

  onSubmit() {
    if (this.configuracaoForm.valid) {
      let id = this.message.loading('Salvando cadastro...').messageId;

        let dadosEdicao = this.configuracaoForm.value;

        this.configuracaoService.atualizar(dadosEdicao).subscribe((p: any) => {
          this.router.navigate(['/configuracao']);
          this.message.remove(id);
          this.message.success('O configuração foi atualizado com SUCESSO!');
        });

    } else {
      for (const i in this.configuracaoForm.controls) {
        this.configuracaoForm.controls[i].markAsDirty();
        this.configuracaoForm.controls[i].updateValueAndValidity();
      }
    }
  }

}
